import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { OverviewTab } from './OverviewTab';
import { CustomerLookupTab } from './CustomerLookupTab';
import { PaymentSearchTab } from './PaymentSearchTab';
import { SubscriptionManagementTab } from './SubscriptionManagementTab';
import { StripeEventsTab } from './StripeEventsTab';

export function PaymentsDashboard() {
  return (
    <div className="w-full max-w-7xl mx-auto p-4 sm:p-8">
      <Link
        to="/dev-console"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground mb-4"
      >
        <ArrowLeft className="h-4 w-4" /> Back to Dev Console
      </Link>

      <h1 className="text-2xl font-bold text-foreground mb-6">Payments & Revenue</h1>

      <Tabs defaultValue="overview">
        {/* Wrap tabs onto multiple rows on a narrow screen rather than
            overflowing the page (the default TabsList is a fixed-height,
            non-wrapping inline-flex; h-auto + flex-wrap lets rows stack). */}
        <TabsList className="mb-6 flex h-auto flex-wrap justify-start gap-1">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="customers">Customers</TabsTrigger>
          <TabsTrigger value="payments">Payments</TabsTrigger>
          <TabsTrigger value="subscriptions">Subscriptions</TabsTrigger>
          <TabsTrigger value="stripe-events">Stripe Events</TabsTrigger>
        </TabsList>

        <TabsContent value="overview">
          <OverviewTab />
        </TabsContent>

        <TabsContent value="customers">
          <CustomerLookupTab />
        </TabsContent>

        <TabsContent value="payments">
          <PaymentSearchTab />
        </TabsContent>

        <TabsContent value="subscriptions">
          <SubscriptionManagementTab />
        </TabsContent>

        <TabsContent value="stripe-events">
          <StripeEventsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
